import React, { useState } from "react";
import useMobile from "../hooks/useMobile";
import { Box, Button, Dialog, DialogTitle, IconButton } from "@mui/material";
import { useUserDataContext } from "../context/UserDataContext";
import { useLoader } from "../context/LoaderContext";
import axios from "axios";
import { failed, success } from "../hooks/useToast";

interface PasswordProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const PasswordPopUp: React.FC<PasswordProps> = ({ open, setOpen }) => {
  const mobile = useMobile();
  const { setLoading } = useLoader();
  const { userData } = useUserDataContext();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
  const [oldPassword, setOldPassword] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [reenterPassword, setReenterPassword] = useState<string>("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const token = localStorage.getItem("frcsit:access-token");
  const sisheaders = { Authorization: `Bearer ${token}` };
  const handleClose = () => {
    setOpen(false);
  };
  const toggleOldPasswordVisibility = () => {
    setShowOldPassword(!showOldPassword);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleRePasswordVisibility = () => {
    setShowRePassword(!showRePassword);
  };
  const validateStep = () => {
    let newErrors: { [key: string]: string } = {};
    let passwordErrorList: string[] = [];
    if (!oldPassword) {
      newErrors.oldpassword = "Old Password is required";
    }
    if (!password) passwordErrorList.push("required");
    if (password.length < 8) passwordErrorList.push("8char");
    if (!/[A-Z]/.test(password)) passwordErrorList.push("uppercase");
    if (!/\d/.test(password)) passwordErrorList.push("number");
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
      passwordErrorList.push("symbol");
    if (!reenterPassword)
      newErrors.reenterPassword = "Please re-enter your password";
    else if (password !== reenterPassword)
      newErrors.reenterPassword = "Passwords do not match";

    setErrors(newErrors);
    setPasswordErrors(passwordErrorList);
    return (
      Object.keys(newErrors).length === 0 && passwordErrorList.length === 0
    );
  };

  // const deleteMember = () => {
  //   onDelete();
  //   setOpen(false);
  // };

  const handleSubmit = async () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    try {
      const userDetail = {
        current_password: oldPassword,
        new_password: password,
        new_password_confirmation: reenterPassword,
      };
      const userRes = await axios.post(
        `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/password-change/${userData?.data?.id}`,
        userDetail,
        {
          headers: sisheaders,
        }
      );
      if (userRes?.status === 200 || userRes?.status === 201) {
        setOldPassword("");
        setPassword("");
        setReenterPassword("");
        setShowOldPassword(false);
        setShowPassword(false);
        setShowRePassword(false);
        setOpen(false);
        setTimeout(() => {
          setLoading(false);
          success();
        }, 1000);
      }
    } catch (e) {
      setLoading(false);
      failed();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      PaperProps={{
        sx: {
          alignSelf: "flex-start",
          borderRadius: 2,
          minWidth: mobile ? "auto" : "400px",
          maxHeight: '800px',
        },
      }}
    >
      <DialogTitle sx={{ padding: "24px 16px 0px 16px" }}>
        <span>Update Password</span>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            fontSize: "15px",
          }}
        >
          <i className="icon-cross1"></i>
        </IconButton>
      </DialogTitle>
      <hr />
      <Box
        display="flex"
        flexDirection="column"
        padding="0px 15px 15px 15px"
        minWidth="300px"
      >
        <div className="col-xl-12">
          <div className="become-volunteer__input">
            <input
              type={showOldPassword ? "text" : "password"}
              placeholder="Enter Old Password"
              name="oldpassword"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className={errors.oldpassword && "error-border"}
            />

            <i
              className={`main-header-two__cart ${
                showOldPassword ? "icon-eye-blocked" : "icon-eye"
              } mini-cart__toggler custom-password-icon`}
              onClick={toggleOldPasswordVisibility}
            ></i>
          </div>
          {errors.oldpassword && (
            <p
              className="error-message"
              style={{
                marginTop: "-30px",
                marginBottom: "2.4em",
              }}
            >
              {errors.oldpassword}
            </p>
          )}
        </div>

        <div className="col-xl-12">
          <div className="become-volunteer__input">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter New Password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={passwordErrors.length > 0 ? "error-border" : ""}
            />
            <i
              className={`main-header-two__cart ${
                showPassword ? "icon-eye-blocked" : "icon-eye"
              } mini-cart__toggler custom-password-icon`}
              onClick={togglePasswordVisibility}
            ></i>
          </div>

          <ul
            className="info-message"
            style={{
              marginTop: "-31px",
              marginBottom: "25px",
            }}
          >
            {passwordErrors.includes("required") && (
              <li className="error-message" style={{ marginLeft: "unset" }}>
                Password is required
              </li>
            )}
            <li
              className={
                passwordErrors.includes("8char") ? "error-message" : ""
              }
              style={{ marginLeft: "unset" }}
            >
              At least 8 characters required
            </li>
            <li
              className={
                passwordErrors.includes("uppercase") ? "error-message" : ""
              }
              style={{ marginLeft: "unset" }}
            >
              At least one uppercase letter
            </li>
            <li
              className={
                passwordErrors.includes("number") ? "error-message" : ""
              }
              style={{ marginLeft: "unset" }}
            >
              At least one number
            </li>
            <li
              className={
                passwordErrors.includes("symbol") ? "error-message" : ""
              }
              style={{ marginLeft: "unset" }}
            >
              At least one symbol
            </li>
          </ul>
        </div>

        <div className="col-xl-12">
          <div className="become-volunteer__input">
            <input
              type={showRePassword ? "text" : "password"}
              placeholder="Enter Confirm Password"
              name="reenterpassword"
              value={reenterPassword}
              onChange={(e) => setReenterPassword(e.target.value)}
              className={errors.reenterPassword && "error-border"}
            />

            <i
              className={`main-header-two__cart ${
                showRePassword ? "icon-eye-blocked" : "icon-eye"
              } mini-cart__toggler custom-password-icon`}
              onClick={toggleRePasswordVisibility}
            ></i>
          </div>
          {errors.reenterPassword && (
            <p
              className="error-message"
              style={{
                marginTop: "-30px",
                marginBottom: "2.4em",
              }}
            >
              {errors.reenterPassword}
            </p>
          )}
        </div>

        <Box display="flex" gap={2} justifyContent="end">
          <Button
            variant="contained"
            sx={{
              backgroundColor: "hsl(6, 78%, 57%);",
              color: "#fff",
              width: "80px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "hsl(6, 78%, 65%)",
              },
            }}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#2BB1CE",
              color: "#fff",
              width: "80px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "#48c5dd",
              },
            }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PasswordPopUp;
